import React from 'react';
import { motion } from 'framer-motion';
import { Home as HomeIcon, Building2, Briefcase, CheckCircle2, Sparkles } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { Link } from 'react-router-dom';
export const Services = () => {
  const {
    t
  } = useLanguage();
  const fadeInUp = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  const services = [{
    id: 'house',
    icon: HomeIcon,
    title: t('services.house.title'),
    desc: t('services.house.desc'),
    image: 'https://images.unsplash.com/photo-1527515637462-cff94eecc1ac?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80'
  }, {
    id: 'apartment',
    icon: Building2,
    title: t('services.apartment.title'),
    desc: t('services.apartment.desc'),
    image: 'https://images.unsplash.com/photo-1502672260266-1c1e52509def?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80'
  }, {
    id: 'office',
    icon: Briefcase,
    title: t('services.office.title'),
    desc: t('services.office.desc'),
    image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80'
  }];
  const benefits = [t('services.benefits.deep'), t('services.benefits.eco'), t('services.benefits.staff'), t('services.benefits.flexible')];
  return <div className="w-full bg-white pt-32 pb-20" data-id="element-311">
      {/* Header */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center mb-20" data-id="element-312">
        <motion.div initial="hidden" animate="visible" variants={fadeInUp} data-id="element-313">
          <h1 className="text-4xl md:text-5xl font-bold text-navy mb-6" data-id="element-314">
            {t('services.title')}
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-315">
            {t('services.subtitle')}
          </p>
        </motion.div>
      </div>

      {/* Services List */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-24" data-id="element-316">
        {services.map((service, index) => <motion.div key={service.id} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={fadeInUp} className={`flex flex-col ${index % 2 === 1 ? 'lg:flex-row-reverse' : 'lg:flex-row'} gap-12 items-center`} data-id="element-317">
            <div className="lg:w-1/2 w-full" data-id="element-318">
              <div className="aspect-[4/3] rounded-3xl overflow-hidden shadow-xl relative group" data-id="element-319">
                <img src={service.image} alt={service.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-320" />
                <div className="absolute inset-0 bg-pink-primary/10 mix-blend-overlay" data-id="element-321"></div>
              </div>
            </div>

            <div className="lg:w-1/2 w-full space-y-6" data-id="element-322">
              <div className="w-16 h-16 bg-pink-lighter rounded-2xl flex items-center justify-center text-pink-primary mb-4" data-id="element-323">
                <service.icon className="w-8 h-8" data-id="element-324" />
              </div>
              <h2 className="text-3xl font-bold text-navy" data-id="element-325">{service.title}</h2>
              <p className="text-lg text-gray-600 leading-relaxed" data-id="element-326">
                {service.desc}
              </p>

              <div className="pt-6 border-t border-gray-100" data-id="element-327">
                <h3 className="font-semibold text-navy mb-4" data-id="element-328">
                  {t('services.benefits.title')}
                </h3>
                <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-329">
                  {benefits.map((benefit, i) => <li key={i} className="flex items-center gap-3 text-gray-600" data-id="element-330">
                      <CheckCircle2 className="w-5 h-5 text-pink-primary shrink-0" data-id="element-331" />
                      <span data-id="element-332">{benefit}</span>
                    </li>)}
                </ul>
              </div>

              <div className="pt-6" data-id="element-333">
                <Link to="/booking" className="inline-flex bg-pink-primary text-white px-8 py-3 rounded-full font-medium hover:bg-pink-hover transition-colors shadow-pink-soft items-center gap-2" data-id="element-334">
                  <Sparkles className="w-4 h-4" data-id="element-335" />
                  {t('nav.bookNow')}
                </Link>
              </div>
            </div>
          </motion.div>)}
      </div>
    </div>;
};